/** The synchronization mode for portal items. */
enum PortalSyncMode {
    SignAndSync,
    SkipSignAndSync,
    Sync
}

export { PortalSyncMode };
